module.exports = {
  WHATSAPP_WIDGET_NAME: 'WHATSAPP',
  WHATSAPP_WIDGET_ID: 'whatsAppWidget',
  WIDGET_EXTRA_WIDTH: 35,
  WIDGET_EXTRA_HEIGHT: 35,
};
